
// Example response from BE
// {
//   "spreadsheetId": "1hEhniiYTf2liMQO68IiDs3pyB7Fk0nSJgh4VUSkhrRo",
//   "lastSyncDate": 1623904574.738000000
// }

export interface IApprovalRequestSyncData {
  lastSyncDate: number;
  spreadSheetId: string;
}
